module.exports = __webpack_public_path__ + "static/img/male-1.18a50334.png";